/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

const YEAR = new Date().getFullYear();
export const EXPIRY = {
	MONTHS: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
	YEARS: Array(10)
		.fill(null)
		.map((_v, i) => `${YEAR + i}`),
};

export const BILLING_ADDRESS_ID = 'billing_address_id';

export const CREDIT_CARD_ACCOUNT: Record<string, boolean> = {
	account: true,
	expire_month: true,
	expire_year: true,
	cc_cvc: true,
	cc_brand: true,
};

export const UNSUPPORTED_FOR_MULTI: Record<string, true> = {
	PayInStore: true,
};

export const PAYMENT_BRAND_IMG_MAP:Record<string,string> = {
	"iDeal": "IDEAL",
	"KLARNA": "KLARNA",
	"PAYPAL": "PAYPAL",
	"Credit Card": "CREDITCARD",
	"Cadeaukaart": "GIFTCARD"
}

export const PAYMENT_BRAND_TYPE_MAP:Record<string,string> = {
	"PAYMENT_PLUGIN_VISA" : "CreditCard~VISA",
	"PAYMENT_PLUGIN_MASTERCARD" : "CreditCard~MasterCard",
	"PAYMENT_PLUGIN_OPENINVOICENL" : "Open Invoice NL~Open Invoice NL",
	"PAYMENT_PLUGIN_KLARNA_PAY_LATER" : "Klarna~Klarna Paylater",
	"PAYMENT_PLUGIN_KLARNA_PAY_IN_3" : "Klarna~Klarna Pay In 3",
	"PAYMENT_PLUGIN_KLARNA" : "Klarna~Klarna",
	"PAYMENT_PLUGIN_IDEAL" : "iDeal~iDeal",
	"PAYMENT_PLUGIN_PAYPAL" : "PAYPAL~PAYPAL",
	"PAYMENT_PLUGIN_INTERTOYSGIFTCARD" : "Intersolve~Intertoys Giftcard",
	"PAYMENT_PLUGIN_BARTSMIT" : "Intersolve~bartsmit",
	"PAYMENT_PLUGIN_TOYSXL" : "Intersolve~ToysXL",
	"PAYMENT_PLUGIN_KIDSCADEAU" : "Intersolve~KidsCadeau",
	"PAYMENT_PLUGIN_AMERICANEXPRESS" : "CreditCard~American Express",
	"PAYMENT_PLUGIN_VVVGIFTCARD" : "Intersolve~VVV Giftcard",
	"PAYMENT_PLUGIN_POS" : "POS",
	"PAYMENT_PLUGIN_DEGIFTCARD" : "Intersolve~DE Giftcard"
}

export const PAYMENT_BRAND_TYPE_TEXT_MAP:Record<string,string> = {
	"CreditCard~VISA": "VISA" ,
	"CreditCard~MasterCard": "MasterCard",
	"Open Invoice NL~Open Invoice NL" : "AfterPay (achteraf betalen)",
	"Klarna~Klarna Paylater" : "Klarna",
	"Klarna~Klarna Pay In 3" : "Klarna",
	"Klarna~Klarna":"Klarna",
	"iDeal~iDeal" : "iDEAL",
	"PAYPAL~PAYPAL" : "PayPal",
	"Intersolve~Intertoys Giftcard" : "Intertoys Kadokaart",
	"Intersolve~bartsmit" : "Bartsmit Cadeaukaart",
	"Intersolve~ToysXL" : "Toys XL Cadeaukaart",
	"Intersolve~KidsCadeau" : "KidsCadeau",
	"CreditCard~American Express" : "American Express",
	"Intersolve~VVV Giftcard" : "VVVCadeaukaart",
	"PAYMENT_PLUGIN_POS" : "betaal aan de kassa",
	"Intersolve~DE Giftcard" : "DE Cadeaukaart"
}


export const CREDIT_GIFT_CARD_PAYMENTS = [
	'Cadeaukaart', 
	'Credit Card', 
	'CreditCard', 
	'Intersolve'
];

export const CLICL_AND_COLLECT_PAYMENTS = ['ideal', 'cadeaukaart'];
